






























import { defineComponent, reactive, toRefs, onMounted, ref, watch } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import ExcelJS from 'exceljs'
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue"
import { BTable } from 'bootstrap-vue';
import { QuestionnaireResult, SearchCondition } from "../../modules/teacher/QuestionnaireResultDownload"

export interface Data {
  condition: SearchCondition
  questinonaireResults: QuestionnaireResult[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      questinonaireResults: [],
      errors: [],
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = async () => {
      await search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {

      state.errors = []

      if(!state.condition.updated_at_from || !state.condition.updated_at_to){
        state.errors.push("回答日を入力してください。");
        return;
      }

      if(!window.confirm("アンケート結果をダウンロードします。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/questionnaire_result_download?${Common.BuildQuery(state.condition, 'search_condition')}`).then(async response => {
        state.questinonaireResults = response.data.questionnaire_results;
        if(state.questinonaireResults.length == 0){
          alert("条件に一致するデータはありませんでした。");
        }else{
          await download();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * ダウンロード
     ******************************/

    const download = async () => {
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet('アンケート結果');
      const worksheet = workbook.getWorksheet('アンケート結果');

      worksheet.columns = [
        { header: '生徒CD', key: 'student_code' },
        { header: '氏名', key: 'student_name' },
        { header: '講座CD', key: 'lesson_code' },
        { header: '科目', key: 'subject_name' },
        { header: '回次', key: 'lesson_class_no' },
        { header: '講座名', key: 'lesson_name' },
        { header: '担当講師', key: 'tantou_user_name' },
        { header: '理解度', key: 'understanding_level' },
        { header: '満足度', key: 'satisfaction_level' },
        { header: 'コメント', key: 'comment' },
      ];

      worksheet.addRows(state.questinonaireResults);

      // ヘッダ列の背景色を設定
      worksheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD9E1F2' }
        };
      });

      // すべてのセルの縦位置を中央寄せに設定 & 罫線を追加
      const totalRows = worksheet.rowCount;
      const totalColumns = worksheet.columnCount;

      for (let rowIndex = 1; rowIndex <= totalRows; rowIndex++) {
        for (let colIndex = 1; colIndex <= totalColumns; colIndex++) {
          const cell = worksheet.getCell(rowIndex, colIndex);

          // コメント列のセルにwrapTextを適用
          if (worksheet.columns[colIndex - 1].key === 'comment' && cell.value) {
            cell.alignment = { wrapText: true, vertical: 'middle' };
          } else {
            // 他のセルの縦位置を中央寄せに設定
            cell.alignment = { vertical: 'middle' };
          }

          // 罫線を追加
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        }
      }

      const uint8Array =
      await workbook.xlsx.writeBuffer()
      const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
      const a = document.createElement('a');
      a.href = (window.URL || window.webkitURL).createObjectURL(blob);
      a.download = `アンケート結果_${moment(state.condition.updated_at_from).format("YMMDD")}～${moment(state.condition.updated_at_to).format("YMMDD")}.xlsx`;
      a.click();
      a.remove();
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      // await search();
    });

    return {
      ...toRefs(state),
      tableRef,
      searchClick,
      search,
      clearCondition,
      download,
    };
  }
});
